import { useAuth } from '@frontend/context/authContext';

import { useQuery } from '@apollo/client';
import { GET_CLIENT_LOGO_QUERY } from '../queries/GetClientLogoQuery';
import { GetClientLogo, GetClientLogoVariables } from '../queries/types/GetClientLogo';

export const useGetClientLogoQuery = () => {
  const { clientInfo } = useAuth();

  const { data, loading, error } = useQuery<GetClientLogo, GetClientLogoVariables>(GET_CLIENT_LOGO_QUERY, {
    variables: { clientId: clientInfo?.id },
    skip: !clientInfo?.id,
  });

  return {
    logoUrl: data?.getBackendServerClientByClientId?.logo_url,
    isLogoLoading: loading,
    logoError: error,
  };
};
